import { svgs } from 'constants'
import React from 'react'
import { Link } from 'react-router-dom'

const CustomHeading = ({ svg, text, down_icon, redirect, type }) => {
    return (
        <div className={`custom-heading w-full sm:w-[390px] mt-2 ${type == 1 ? "h-[30px]" : type == 2 ? "h-[24px]" : type == 3 ? "h-[40px]" : ""}`}>
            <div className={`flex w-full ${type == 3 ? "justify-center items-center text-[16px]" : "justify-between"}`}>
                <div className='flex items-center px-1'>
                    {svg && <span>{svg}</span>}
                    {text && <span className='px-2'>{text}</span>}
                    {down_icon && <span>{svgs.down_arrow}</span>}
                </div>
                {redirect &&
                    <Link to={redirect} className='flex items-center text-[#3EFFA5] capitalize'>
                        <span className='mr-1'>
                            View All
                        </span>
                        {svgs.right_arrow}
                    </Link>}
            </div>
        </div >
    )
}

export default CustomHeading